import React from 'react';

const Introduction = () => {
  return (
    <React.Fragment>
      <h1>Introduction</h1>
      <p>
        Cureus channels are a branded section of the <a href='/'>Cureus Journal of Medical Science</a> devoted to highlighting and promoting the scholarly output of channel organizations and their members. A channel represents a contractual relationship between each channel organization and the journal that, for most channel types, enables their authors to avoid potential editing fees when submitting articles for peer review and publication. Channels also serve as a venue for posting meeting abstracts, posters, announcements and other content produced by channel members, faculty, residents, and/or medical students.
      </p>
    </React.Fragment>
  )
}

export default Introduction;

